export default __webpack_public_path__ + "static/media/price-change-since-drop.7b89c14e.svg";